export const IMAGE_GENERATION_PLATFORM_MAX_DURATION_MS = 300_000;

// Keep provider and fetch aborts below Vercel's 300s function ceiling so the
// route has time to serialize the response and persist generated assets.
export const IMAGE_GENERATION_PROVIDER_TIMEOUT_MS = 285_000;
export const IMAGE_GENERATION_HTTP_TIMEOUT_MS = IMAGE_GENERATION_PROVIDER_TIMEOUT_MS;
export const IMAGE_GENERATION_TOOL_TIMEOUT_MS = 295_000;

export const IMAGE_GENERATION_UI_LONG_RUNNING_MS = 240_000;
export const IMAGE_GENERATION_TIMEOUT_SECONDS = Math.round(
  IMAGE_GENERATION_PROVIDER_TIMEOUT_MS / 1000,
);

export const IMAGE_GRID_MIN_CELL_TIMEOUT_MS = 45_000;
export const IMAGE_GRID_TOTAL_HEADROOM_MS = 10_000;

/**
 * A `concept_renditions.is_generating` row older than this is orphaned, not
 * in-flight — no real provider call runs anywhere near this long. Set well
 * past `IMAGE_GENERATION_PROVIDER_TIMEOUT_MS` (285s) so a genuinely slow-but-
 * live request is never reconciled out from under itself; the gap covers
 * upload + media-library write + credit settlement after the provider
 * responds. See `reconcileStaleGenerations` (ConceptRenditionService.ts).
 */
export const CONCEPT_RENDITION_GENERATION_STALE_TIMEOUT_MS = 360_000;
